module.exports = __webpack_public_path__ + "img/banner5.12e1c23c.png";